import { useEffect, useState } from "react";
import { useAbortController } from "./useAbortController";
import {
  IPaginacionApi,
  ITableDTO,
} from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import axios from "axios";
import {
  ITablaGruposDocumentos,
  IfilteApiGrupo,
} from "../../../Interfaces/gestionDocumentos/IGrupoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";

export const useGruposDocumentos = () => {
  const { handleAbortController } = useAbortController();
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<ITablaGruposDocumentos[]>([]);
  const [total, setTotal] = useState(0);
  const [responseAPI, setresponseAPI] = useState<ITableDTO>();

  const [filter, setFilter] = useState<IfilteApiGrupo>({
    skip: 0,
    take: 50,
    search: "",
  });

  const postListaTabla = (filter: IfilteApiGrupo) => {
    setLoading(true);
    if (filter.tipoDocumentoId != "") {
      grupoDocumentoService
        .listarGrupos(filter, handleAbortController())
        .then((res) => {
          if (res.status == 200) {
            setresponseAPI(res.data);
            setItems(res?.data?.items);
            setTotal(res?.data?.total);
            setLoading(false);
          }
        })

        .catch((e) => {
          if (axios.isCancel(e)) {
          } else {
            console.error("Error en la solicitud:", e?.message);
            setLoading(false);
          }
        });
    }
  };

  const limpiarFiltro = () => {
    setFilter({ ...filter, skip: 0, take: 50, search: "" });
  };

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take });
  };

  const onChangeSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  const onChangeTextSearch = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setFilter({ ...filter, search: newValue });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };

  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
  };

  const paginacionTable: IPaginacionApi = {
    onChangeTake: onChangeTake,
    onChangeSkip: onChangeSkip,
    totalPagesPagination: Number.parseInt(responseAPI?.pages!),
    skipPagination: filter.skip,
    takePagination: filter.take,
    isVisible: true,
    isLoading: loading,
    total: items ? Number.parseInt(responseAPI?.total!) : 0,
  };

  useEffect(() => {
    postListaTabla(filter);
  }, [filter]);

  return {
    items,
    loading,
    filter,
    setFilter,
    limpiarFiltro,
    total,
    postListaTabla,
    paginacionTable,
    onChangeTextSearch,
  };
};
